import getThreadId from '@/lib/threads/getThreadId.js';
import normalizeThreadType from '@/lib/threads/normalizeThreadType.js';

/**
 * Removes threads of one automation type whose id the server's authoritative
 * list no longer returns. Threads of any other type pass through untouched, and
 * the original array is returned when nothing changes so consumers can skip work.
 */
const pruneStaleAutomationThreads = ({ threads = [], threadType, authoritativeThreadIds = [] } = {}) => {
  const threadList = Array.isArray(threads) ? threads : [];

  if (threadList.length === 0) {
    return threadList;
  }

  const targetThreadType = normalizeThreadType(threadType, 'default');
  const liveThreadIds = new Set();

  for (const threadId of Array.isArray(authoritativeThreadIds) ? authoritativeThreadIds : []) {
    const normalizedThreadId = String(threadId || '').trim();

    if (normalizedThreadId) {
      liveThreadIds.add(normalizedThreadId);
    }
  }

  const nextThreads = threadList.filter((thread) => {
    const currentThreadType = normalizeThreadType(thread?.threadType || thread?.thread_type, 'default');

    if (currentThreadType !== targetThreadType) {
      return true;
    }

    return liveThreadIds.has(getThreadId(thread));
  });

  return nextThreads.length === threadList.length ? threadList : nextThreads;
};

export default pruneStaleAutomationThreads;
